import useTransformPointsHistoryItemData from './useTransformPointsHistoryItemData'

export default useTransformPointsHistoryItemData
